import { initializeApp, getApps, getApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getFunctions, type Functions } from 'firebase/functions';

// Firebase configuration - should be provided via environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAFWX6Bs_G9_7D9xBPWkJIjerd6PmQe0pI",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "events-payment.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "events-payment",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "events-payment.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "181973615733",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:181973615733:web:7393dd61925b38585b243c"
};

// Initialize Firebase (avoid duplicate initialization)
let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const functions: Functions = getFunctions(app);

export { app };
